import React from 'react';

const SIZE_MAP = {
  small:  { mobile: 'w-8 h-8',  desktop: 'lg:w-9 lg:h-9',   mobileText: 'text-sm',   desktopText: 'lg:text-base', label: 'text-[7px] lg:text-[8px]' },
  medium: { mobile: 'w-10 h-10', desktop: 'lg:w-11 lg:h-11', mobileText: 'text-base', desktopText: 'lg:text-xl',   label: 'text-[8px] lg:text-[9px]' },
  large:  { mobile: 'w-12 h-12', desktop: 'lg:w-14 lg:h-14', mobileText: 'text-lg',   desktopText: 'lg:text-2xl',  label: 'text-[9px] lg:text-[10px]' },
};

const GAP_MAP = { tight: 'gap-1 lg:gap-2', normal: 'gap-2 lg:gap-3', spacious: 'gap-3 lg:gap-4' };
const POS_MAP = {
  top:          'top-1/4 -translate-y-1/4',
  'upper-third': 'top-1/3 -translate-y-1/3',
  center:       'top-1/2 -translate-y-1/2',
};

export default function FloatingMenu({ cartCount, vocabCount, marketplaceBadge, tradeBadge, onCart, onCloset, onMarketplace, onTrade, onWallet, onDashboard, onDressUp, onVocab, ambientOn, onToggleAmbient, onHelp, settings = {} }) {
  const mobileSize = settings.fm_menu_mobile_size || 'small';
  const desktopSize = settings.fm_menu_desktop_size || 'medium';
  const gap = settings.fm_menu_gap || 'tight';
  const position = settings.fm_menu_position || 'upper-third';

  const ms = SIZE_MAP[mobileSize] || SIZE_MAP.small;
  const ds = SIZE_MAP[desktopSize] || SIZE_MAP.medium;
  const gapClass = GAP_MAP[gap] || GAP_MAP.tight;
  const posClass = POS_MAP[position] || POS_MAP['upper-third'];

  const items = [
    onCart && { icon: settings.icon_cart_menu || '🛒', label: settings.menu_cart || 'Cart', badge: cartCount, onClick: onCart },
    onCloset && { icon: settings.icon_closet_menu || '👗', label: settings.menu_closet || 'Closet', onClick: onCloset },
    onTrade && { icon: settings.icon_trade_menu || '🔄', label: settings.menu_trade || 'Trade', badge: tradeBadge, onClick: onTrade },
    onMarketplace && { icon: settings.icon_marketplace || '🏪', label: settings.menu_marketplace || 'Market', badge: marketplaceBadge, onClick: onMarketplace },
    { icon: settings.icon_wallet_menu || '💰', label: settings.menu_wallet || 'Wallet', onClick: onWallet },
    { icon: settings.icon_stats_menu || '📊', label: settings.menu_stats || 'Stats', onClick: onDashboard },
    { icon: settings.icon_style_menu || '👤', label: settings.menu_style || 'Style', onClick: onDressUp },
    onVocab && { icon: settings.icon_vocab_menu || '📖', label: settings.menu_vocab || 'Words', badge: vocabCount, onClick: onVocab },
    onToggleAmbient && { icon: ambientOn ? (settings.icon_sound_on || '🔊') : (settings.icon_sound_off || '🔇'), label: ambientOn ? (settings.menu_sound_on || 'Sound') : (settings.menu_sound_off || 'Mute'), onClick: onToggleAmbient },
    { icon: settings.icon_help_menu || '❓', label: settings.menu_help || 'Help', onClick: onHelp },
  ].filter(Boolean);

  return (
    <div className={`fixed right-1 lg:right-2 ${posClass} z-50 flex flex-col ${gapClass} animate-slide-right`}>
      {items.map(item => (
        <button
          key={item.label}
          onClick={item.onClick}
          className="relative flex flex-col items-center group"
          title={item.label}
        >
          <div className={`${ms.mobile} ${ds.desktop} rounded-full bg-white/90 backdrop-blur-sm shadow-md border border-gray-100 flex items-center justify-center ${ms.mobileText} ${ds.desktopText} hover:shadow-lg hover:bg-white transition-all`}>
            {item.icon && (item.icon.startsWith('/') || item.icon.startsWith('http'))
              ? <img src={item.icon} alt={item.label} className="w-5 h-5 lg:w-6 lg:h-6 object-contain" />
              : item.icon}
            {item.badge > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[8px] lg:text-[9px] font-bold rounded-full w-3.5 h-3.5 lg:w-4 lg:h-4 flex items-center justify-center">
                {item.badge > 9 ? '9+' : item.badge}
              </span>
            )}
          </div>
          <span className={`${ms.label} text-gray-500 font-medium mt-0.5 leading-none`}>{item.label}</span>
        </button>
      ))}
    </div>
  );
}
